import React from 'react';

// Hand-rolled SVG sparkline — Recharts is overkill at this scale.
// Renders a smoothed-ish polyline + faint area fill, one stroke color
// per row. Empty / all-zero series → renders a flat baseline.
export default function MiniSparkline({ values, color = '#2B203E', width = 140, height = 36 }) {
  const arr = (values || []).slice(0, 12).map((v) => Number(v) || 0);
  while (arr.length < 12) arr.push(0);

  const max = Math.max(...arr, 1);
  const padX = 2;
  const padY = 4;
  const innerW = width - padX * 2;
  const innerH = height - padY * 2;
  const step = innerW / 11;

  const pts = arr.map((v, i) => {
    const x = padX + i * step;
    const y = padY + innerH - (v / max) * innerH;
    return [x, y];
  });

  const polyline = pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const baseline = padY + innerH;
  const areaPath =
    `M ${pts[0][0].toFixed(1)},${baseline.toFixed(1)} ` +
    pts.map(([x, y]) => `L ${x.toFixed(1)},${y.toFixed(1)}`).join(' ') +
    ` L ${pts[pts.length - 1][0].toFixed(1)},${baseline.toFixed(1)} Z`;

  const totalSum = arr.reduce((s, v) => s + v, 0);

  return (
    <svg
      className="billing-list__sparkline"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
    >
      {totalSum > 0 ? (
        <>
          <path d={areaPath} fill={color} fillOpacity="0.12" stroke="none" />
          <polyline
            points={polyline}
            fill="none"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      ) : (
        <line
          x1={padX}
          y1={baseline}
          x2={padX + innerW}
          y2={baseline}
          stroke="#D6D3D1"
          strokeWidth="1"
        />
      )}
    </svg>
  );
}
